import { css } from '@emotion/react'
import { Modal, ModalBody, ModalHeader } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'

import { AnexoArquivosTable } from '../../objetivo/anexo-arquivos/components/table/AnexoArquivosTable'
import { AnexoArquivoRowModel } from '../../objetivo/anexo-arquivos/model-anexoArquivos'

interface AnexoArquivosListagemModalProps {
  onClose: () => void
  arquivos: AnexoArquivoRowModel[]
}

export function AnexoArquivosListagemModal(props: Readonly<AnexoArquivosListagemModalProps>) {
  const { onClose, arquivos } = props

  const { profissional: profissionalSessao } = useAcessoLotacaoOrEstagio()

  const profissional = { id: profissionalSessao.id, nome: profissionalSessao.nome }

  return (
    <Modal open size='large' onClose={onClose}>
      <ModalHeader title='Anexo de arquivo' />
      <ModalBody style={styles.modalBody}>
        <AnexoArquivosTable arquivosAnexadosDatabase={arquivos} readOnly profissional={profissional} />
      </ModalBody>
    </Modal>
  )
}

const styles = {
  modalBody: css`
    padding: 0;
  `,
}
